import type { ReactNode } from "react";

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  extra?: ReactNode;
}

export default function SectionTitle({ title, subtitle, extra }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-6">
      <div className="flex items-center gap-3">
        <span className="w-1.5 h-7 rounded-full bg-accent-500" />
        <div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="text-sm text-foreground-500 mt-1">{subtitle}</p>
          )}
        </div>
      </div>
      {extra}
    </div>
  );
}